import { create } from 'zustand';

import { QuizState, QuizActions, Quiz } from './types';

const initialQuizState: QuizState = {
  quizId: undefined,
  quiz: undefined,
};

export const useQuizStore = create<QuizState & QuizActions>((set) => ({
  ...initialQuizState,

  setQuizId: (quizId?: string) => set({ quizId }),
  setQuiz: (quiz?: Quiz) => set({ quiz }),
}));
